<template>
  <div class="sDetail">
    <!-- <div class="head">
      <img src="../../assets/images/fanhui.png" alt @click="prevPage" />
      <p class="t-title" style="margin:0">{{shortName}}</p>
    </div> -->
    <p class="week" v-if="orgType == 2">本期为周末班，暂无就业</p>
    <div v-if="(obtainInfoList.type !== 2 && studentList) && orgType !==2">   
    <table v-if="studentList.length">
      <thead>
        <tr>
          <th style="width:15%">姓名</th>
          <th style="width:12%">学历</th>
          <th style="width:25%">毕业学校</th>
          <th style="width:21%">专业</th>
          <th style="width:27%">就业企业</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in studentList" :key="index">
          <td class="td-name"><img class="stu-name" :src="'data:image/bitmap;base64,'+ item.name" alt=""></td>
          <!-- <td v-html="item.name">{{item.name}}</td> -->
          <td v-html="item.degree" style="background:#f0f5fa">{{item.degree}}</td>
          <td v-html="item.lastSchool">{{item.lastSchool}}</td>
          <td v-html="item.major" style="background:#f0f5fa">{{item.major}}</td>
          <td v-html="item.company">
            <p style="width:89%">{{item.company}}</p>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="weekend">
      <p>数据加载中...</p>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detailId:{
      type: Number,
      default: ''
  },
  orgId:{
      type: Number,
      default: ''
  },
  orgType:{
      type: Number,
      default: ''
  },
   obtainInfoList: {
      type: Object,
      default: ()=>{}   
    }
  },
  data() {
    return {
      shortName: "",
      studentList: "",
    };
  },
  watch: {
     detailId(v) {
      this.getInfo()
    },
    obtainInfoList(value) {
      if(value) {
        this.studentList = value.list
      }
    },
    orgType(v) {
      // console.log(v)
    }
  },
  methods: {
    getInfo() {
      this.axios
      .get("/api/consume/ObtainInfo/ObtainInfoListWithOrgInfo", {
        params: {
          OrgId:this.orgId,
          SemesterId:this.detailId,
          Width: 102,
          Height: 48,
          FontSize: 14,
          fontName: 'Microsoft Yahei'
        }
      })
      .then(res => {
        this.studentList = res.data.list;
        // this.shortName = res.data.title;
      });
    },
    prevPage() {
      this.$personBack()
    },
  }
};
</script>

<style scoped>
.sDetail {
  /* background: #f8f8f8; */
  margin-top: -5px;
}
.sDetail .head {
  background: #f8f8f8;
  height: 102px;
  text-align: center;
  padding: 0 35.5px;
}
.sDetail .head img {
  width: 14.54px;
  height: 34px;
  margin-top: 36px;
  float: left;
}
.sDetail .head .t-title {
  font-size: 30px;
  color: #282828;
  line-height: 102px;
  width: 100%;
}
.sDetail .week {
  font-size: 22px;
  text-align: center;
  color: #ccc;
  margin-top: 15px;
}
table {
  background-color: #fff;
  border-collapse: collapse;
  width: 700px;
  margin: 20px auto;
  table-layout: fixed;
  margin-bottom: 40px;
  border-radius: 20px;
}

th {
  color: #fff;
  cursor: pointer;
  line-height: 63px;
  font-weight: normal;
  font-size: 24px;
  border-right: 1px solid #7caff4;
}
thead {
  overflow: hidden;
  width: 90%;
  border-radius: 20px;
  background: #6f9eff;
}
tr {
  height: 36px;
  border-radius: 20px;
  overflow: hidden;
}

td {
  background-color: #f9f9f9;
  line-height: 51px;
  font-size: 20px;
  color: #565656;
  padding: 0 10px;
}
th {
  line-height: 54px;
}
td {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #e2e2e2;
}
.td-name {
  position: relative;
}
.stu-name {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 26px;
  top: 10px;
  
}
.company {
  overflow: hidden;
  padding-right: 10px;
  padding-left: 12px;
}
.weekend {
  background: #6f9eff;
  width: 90%;
  height: 76px;
  margin: 0 auto;
  text-align: center;
  border-radius: 10px;
  margin-top: 40px;
}
.weekend p {
  line-height: 76px;
  color: #ffffff;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/jiuye/SemesterDetail.vue